import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import {
    getTrendingColoursApi,
    setTrendingColourOrderApi,
    sortTrendingColoursApi,
    toggleTrendingColourApi
} from "../../../services/manage-product/setting/trendingColourService";


export const getAllTrendingColours = createAsyncThunk('trendingColour/getAllTrendingColours', async (filters, {dispatch}) => {
    const response = await getTrendingColoursApi(filters);
    return response.response;
});

export const sortTrendingColours = createAsyncThunk('trendingColour/sortTrendingColours', async (payload, {dispatch}) => {
    try {
        const response = await sortTrendingColoursApi(payload);
        const data = await response.response;
        dispatch(getAllTrendingColours());
        toast.success("Sort order updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return data;
    } catch (e) {
        return Promise.reject(e);
    }
});

export const toggleTrendingColour = createAsyncThunk('trendingColour/toggleTrendingColour', async (colour, {dispatch}) => {
    try {
        const response = await toggleTrendingColourApi(colour.id, {is_trending: colour.is_trending});
        await response.response;
        toast.success("Trending colour updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return {id: colour.id, is_trending: colour.is_trending};
    } catch (e) {
        // Put the grid back in sync with the server before surfacing the failure.
        dispatch(getAllTrendingColours());
        return Promise.reject(e);
    }
});

// Writes one row's slot number. Deliberately does NOT re-fetch: the grid is left in place
// so a run of numbers can be typed down the list without rows jumping around mid-entry.
// The new order applies on the next load. Confirmed as the wanted behaviour — do not add
// a refetch here.
export const setTrendingColourOrder = createAsyncThunk('trendingColour/setTrendingColourOrder', async (colour, {dispatch}) => {
    try {
        const response = await setTrendingColourOrderApi(colour.id, {sort_order: colour.sort_order});
        await response.response;
        toast.success("Sort order updated successfully", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return {id: colour.id, sort_order: colour.sort_order};
    } catch (e) {
        dispatch(getAllTrendingColours());
        return Promise.reject(e);
    }
});

const trendingColourSlice = createSlice({
    name: 'trendingColour',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: {
        [getAllTrendingColours.fulfilled]: (state, action) => {
            state.data = action.payload ? action.payload : [];
        },
        [setTrendingColourOrder.fulfilled]: (state, action) => {
            const row = state.data.find(item => item.id === action.payload.id);
            if (row) {
                row.sort_order = action.payload.sort_order;
            }
        },
        [toggleTrendingColour.fulfilled]: (state, action) => {
            const row = state.data.find(item => item.id === action.payload.id);
            if (row) {
                row.is_trending = action.payload.is_trending;
            }
        }
    }
});

export default trendingColourSlice.reducer;
